import React from "react";
import { Box, Typography } from "@mui/material";
import { NAVY } from "../../../theme/tokens";
import { WidgetType, WIDGET_LABELS } from "./types";
import { PresetZone } from "./presets";

/**
 * Scaled mini-diagram of a set of zones (percentages → absolute boxes).
 * Shared by the layout-preset cards and the Smart Layout preview so both
 * read identically.
 */

// Muted tint per widget type so the mini-preview reads at a glance.
export const WIDGET_TINT: Record<WidgetType, string> = {
  image: "#3B82F6",
  video: "#8B5CF6",
  website: "#0EA5E9",
  iframe_map: "#059669",
  iframe_embed: "#7C3AED",
  text: "#64748B",
  clock: "#0D9488",
  weather: "#F59E0B",
  qr: "#111827",
  menu_board: "#DC2626",
};

interface MiniLayoutPreviewProps {
  zones: PresetZone[];
  aspect: string;
  showLabels?: boolean;
}

const MiniLayoutPreview: React.FC<MiniLayoutPreviewProps> = ({ zones, aspect, showLabels = false }) => (
  <Box sx={{
    position: "relative", width: "100%", aspectRatio: aspect,
    bgcolor: NAVY, borderRadius: 0.5, overflow: "hidden",
  }}>
    {zones.map((zn, i) => (
      <Box key={i} sx={{
        position: "absolute",
        left: `${zn.x}%`, top: `${zn.y}%`,
        width: `${zn.width}%`, height: `${zn.height}%`,
        border: "1px solid rgba(255,255,255,0.35)",
        bgcolor: WIDGET_TINT[zn.widgetType],
        opacity: 0.85,
        display: "flex", alignItems: "center", justifyContent: "center",
        overflow: "hidden",
      }}>
        {showLabels && (
          <Typography sx={{
            fontSize: 9, fontWeight: 700, color: "#fff", px: 0.5,
            textAlign: "center", lineHeight: 1.1, textShadow: "0 1px 2px rgba(0,0,0,0.4)",
          }}>
            {WIDGET_LABELS[zn.widgetType]}
          </Typography>
        )}
      </Box>
    ))}
  </Box>
);

export default MiniLayoutPreview;
